var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('Navbar'),_c('Section',{attrs:{"title":"What is BEX?","small-text":"","component-name":"WhatBEX"}}),_c('Section',{attrs:{"title":"Why BEX?","small-text":"","component-name":"WhyBEX"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }